document.addEventListener('DOMContentLoaded', function () {
    const accordions = document.querySelectorAll(".faqSection_accordion_item");
    const openAccordion = (accordion) => {
        const content = accordion.querySelector(".faqSection_accordion_item--body");
        accordion.classList.add("active_accordion");
        content.style.maxHeight = content.scrollHeight + "px";
    };
    const closeAccordion = (accordion) => {
        const content = accordion.querySelector(".faqSection_accordion_item--body");
        accordion.classList.remove("active_accordion");
        content.style.maxHeight = null;
    };
    var firstAccordionItem = document.querySelector('.faqSection_accordion_item');
    if (firstAccordionItem) {
        openAccordion(firstAccordionItem);
    }
    accordions.forEach((accordion) => {
        const accTitle = accordion.querySelector(".faqSection_accordion_item--title");
        const content = accordion.querySelector(".faqSection_accordion_item--body");
        accTitle.onclick = () => {
            if (content.style.maxHeight) {
                closeAccordion(accordion);
            } else {
                accordions.forEach((accordion) => closeAccordion(accordion));
                openAccordion(accordion);
            }
        };
    });
});
